import Table from "../../../Components/Table/Table";
import SVG from "../../../Components/SVG";
import Custom from "../../../Components/Buttons/Custom";
import { formatTradePrice } from "../../../helper/formatTradePrice";
import { toJalaliDateTime } from "../../../helper/toJalaliDateTime";
import { displayNumber, displayValue, hasDisplayValue } from "../../../helper/displayValue";
import LeverageModeDisplay from "../../../Components/LeverageModeDisplay";

const money = (value) => {
  if (!hasDisplayValue(value)) return "-";
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return "-";
  return numeric < 0 ? `-$${displayNumber(Math.abs(numeric), { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : `$${displayNumber(numeric, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
export default function TradeHistory({ accountData }) {
  const leverageMode =
    accountData?.account?.leverage_mode ??
    accountData?.trading_terms?.leverage_mode ??
    accountData?.leverage_mode;
  // Admin trade-history responses are paginated; trader responses keep `trades`.
  const trades = Array.isArray(accountData?.results)
    ? accountData.results
    : Array.isArray(accountData?.trades)
      ? accountData.trades
      : [];

  return (
    <div className="w-full p-5 flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="flex justify-between items-center">
        <h3 className="flex gap-2.5 items-center">
          <SVG
            name="archive"
            classname="size-5 stroke-zi-text-light dark:stroke-zi-text-dark"
          />
          <p className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
            تاریخچه معاملات
          </p>
        </h3>
        <Custom
          text="دانلود CSV"
          className="bg-zi-gradient-button-blue !px-5 !py-2 !rounded-full text-zi-text-dark hocus:ring-1 hocus:ring-offset-1 hocus:ring-zi-border-dark"
        />
      </div>

      {trades.length > 0 ? (
        <Table
          showEmptyState
          isLTR={true}
          columns={[
            { key: "uuid", label: "کد معامله" },
            { key: "openTime", label: "زمان باز شدن" },
            { key: "openPrice", label: "قیمت باز شدن" },
            { key: "closeTime", label: "زمان بسته شدن" },
            { key: "closePrice", label: "قیمت بسته شدن" },
            { key: "pnl", label: "سود" },
            { key: "volume", label: "حجم" },
            { key: "leverage", label: "اهرم" },
            { key: "commission", label: "کمیسیون" },
            { key: "netPNL", label: "سود خالص" },
            { key: "symbol", label: "نماد" },
            { key: "tradeType", label: "نوع معامله" },
            // {
            //   key: "detail",
            //   label: "جزئیات",
            //   render: (value) => (
            //     <TableButton
            //       text="مشاهده"
            //       href=""
            //       className="!py-1 !px-2 !rounded-md bg-zi-bg1-light dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark"
            //     />
            //   ),
            // },
          ]}
          data={trades.map((trade) => ({
            uuid: displayValue(trade.id),
            openTime: toJalaliDateTime(trade.opened_at),
            openPrice: formatTradePrice(trade.entry_price),
            closeTime: toJalaliDateTime(trade.closed_at),
            closePrice: formatTradePrice(trade.exit_price),
            pnl: money(trade.profit_loss),
            volume: displayNumber(trade.margin_usdt),
            leverage: (
              <LeverageModeDisplay
                mode={leverageMode}
                values={[trade.leverage]}
              />
            ),
            commission: "$0",
            netPNL: money(trade.profit_loss),
            symbol: hasDisplayValue(trade.symbol) ? String(trade.symbol).toUpperCase() : "-",
            tradeType: trade.side === "long" ? "Buy" : trade.side === "short" ? "Sell" : "-",
            detail: "",
          }))}
        />
      ) : (
        <Table
          isLTR={true}
          columns={[
            { key: "uuid", label: "کد معامله" },
            { key: "openTime", label: "زمان باز شدن" },
            { key: "openPrice", label: "قیمت باز شدن" },
            { key: "closeTime", label: "زمان بسته شدن" },
            { key: "closePrice", label: "قیمت بسته شدن" },
            { key: "pnl", label: "سود" },
            { key: "volume", label: "حجم" },
            { key: "leverage", label: "اهرم" },
            { key: "commission", label: "کمیسیون" },
            { key: "netPNL", label: "سود خالص" },
            { key: "symbol", label: "نماد" },
            { key: "tradeType", label: "نوع معامله" },
            // {
            //   key: "detail",
            //   label: "جزئیات",
            //   render: (value) => (
            //     <TableButton
            //       text="مشاهده"
            //       href=""
            //       className="!py-1 !px-2 !rounded-md bg-zi-bg1-light dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark"
            //     />
            //   ),
            // },
          ]}
          data={[]}
        />
      )}
    </div>
  );
}
